import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type {
  TicketPaperSlice,
  TicketPapersFilters,
} from "./ticketPapersTypes.ts";

const initialState: TicketPaperSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const ticketPapersSlice = createSlice({
  name: "ticketPapers",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<TicketPaperSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<TicketPaperSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof TicketPapersFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<TicketPaperSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  ticketPapersSlice.actions;

export const selectPage = (state: RootState) => state.ticketPapers.page;
export const selectRowsPerPage = (state: RootState) =>
  state.ticketPapers.rowsPerPage;
export const selectFilter = (state: RootState) => state.ticketPapers.filter;
export const selectSort = (state: RootState) => state.ticketPapers.sort;

export default ticketPapersSlice.reducer;
